import { isAfter, format, parseISO } from 'date-fns';

import { EDateTemplate } from '#core/const/date-template';

export const getClosestBonus = (bonuses?: Array<{ date?: string, amount?: number }>) => {
    const now = new Date();

    if(!bonuses) {
        return null;
    }

    const closestBonus = bonuses
        .filter((bonus) => bonus.date && isAfter(parseISO(bonus.date), now))
        .sort((a, b) => {
            if(a.date && b.date) {
                return parseISO(a.date).getTime() - parseISO(b.date).getTime();
            }

            return 0;
        })
        .shift();

    if(!closestBonus) {
        return null;
    }

    return {
        ...closestBonus,
        date  : closestBonus.date ? format(parseISO(closestBonus.date), EDateTemplate.YearLongMonthShortDayDotted) : undefined,
        amount: closestBonus.amount !== undefined ? closestBonus.amount : undefined
    };
};
